import { useContext } from 'react'

import { EmailAccounts } from '../../context'

export function useEmailAccountsContext() {
  return useContext(EmailAccounts)
}
